import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { InfoBookingApiError } from './types/errors.types';
import { setApiError } from '../features/errors/errorsSlice';
import { useAppDispatch } from '../app/hooks';
import { useLocale } from '../locales/useLocale';
import { LOCALES } from './constants';

const ApiErrorInfo = ({
  Source,
  Exception,
  Message,
  ErrorCode,
  InfoBookingErrorId,
}: InfoBookingApiError) => {
  const dispatch = useAppDispatch();
  const [modalShow, setModalShow] = React.useState(true);
  const { currentLocale } = useLocale();

  const closeInfo = () => {
    setModalShow(false);
    dispatch(setApiError(null));
  };

  return (
    <Modal
      show={modalShow}
      onHide={closeInfo}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {currentLocale === LOCALES.Fi
            ? 'Sovelluksessa tapahtui virhetilanne!'
            : 'An error occurred in the application!'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {ErrorCode !== 400 && (
          <p>
            <strong>Statuscode</strong>: {ErrorCode}
          </p>
        )}
        {ErrorCode !== 400 && (
          <p>
            <strong>Source</strong>: {Source}
          </p>
        )}
        {ErrorCode !== 400 && (
          <p>
            <strong>ErrorID</strong>: {InfoBookingErrorId}
          </p>
        )}
        {ErrorCode !== 400 && (
          <pre
            className="error-message text-wrap"
            style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
          >
            {Exception}
          </pre>
        )}
        {ErrorCode === 400 && (
          <pre
            className="error-message text-wrap"
            style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
          >
            {Message}
          </pre>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={closeInfo}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ApiErrorInfo;
